module.exports = __webpack_public_path__ + "img/image_gateway_mhs1.3e7857f8.svg";